/**
 * i18n configuration — react-i18next
 * Single locale (English) for this project.
 * Add additional languages by placing locale files in ./locales/ and extending resources below.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    // React already escapes values; XSS-safe without re-escaping.
    escapeValue: false,
  },
});

export default i18n;
